import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { SurveyLayoutComponent } from '../../components';
import { EvaluateSubmitComponent } from '../../components/evaluate-submit/evaluate-submit.component';
import { SurveyOutroDirective } from '../../components/survey-outro/survey-outro.component';
import { surveyAction, SurveyComponent } from '../survey';
import { surveyFeature } from '../survey/survey.selectors';
import { evaluateSurveyAction } from './evaluate-survey.actions';

@Component({
  selector: 'lib-evaluate-survey',
  templateUrl: './evaluate-survey.component.html',
  styleUrls: ['./evaluate-survey.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    SurveyComponent,
    SurveyLayoutComponent,
    SurveyOutroDirective,
    EvaluateSubmitComponent,
  ],
})
export class EvaluateSurveyComponent {
  private store = inject(Store);

  readonly template$ = this.store.select(surveyFeature.selectSurveyTemplate);

  onSurveyLoad() {
    this.store.dispatch(evaluateSurveyAction.loadEvaluateSurvey());
  }

  onPageChange() {
    // nothing
  }

  onSubmit() {
    this.store.dispatch(evaluateSurveyAction.submitAnswer());
    // show outro anyway
    this.store.dispatch(surveyAction.nextPage());
  }
}
